import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

class ModalConfirm extends Component {

    render() {
        const {isVisible, onClose, onSubmit, title, body, submitButtonText, styles} = this.props;
        return (
            <Modal show={ isVisible } onHide={ onClose }>
              <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {body}
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={ onClose }>Cancel</Button>
                <Button onClick={ onSubmit } bsStyle={styles || 'danger'}>{submitButtonText}</Button>
              </Modal.Footer>
            </Modal>
            );
    }
}

export default ModalConfirm;


// WEBPACK FOOTER //
// ./src/components/common/modals/modal-confirm.js